<template>
  <div>
    <div class="div_footer_under">
      <div class="layout">
        <div class="display_center div_footer_img">
          <Logo />
        </div>
        <div class="display_center">
          <div class="line_h" v-if="copyRight == ''">
            版权所有：上海科探信息技术有限公司&nbsp;&nbsp;&nbsp;沪ICP备15011261号
          </div>
          <div v-else>
              <div class="line_h" v-for="item in copyRight">
                {{ item }}
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/todoCenter/logo";
export default {
  name: "",
  data() {
    return { copyRight: "", footerBool: false, logoUrl: "", logoError: false };
  },
  watch: {
    EnterpriseId: {
      handler(val, oldval) {
        if (val) {
          // this.indexImgUrl();
          this.copyRight = this.$store.getters.getUserInfo.enterprise.copyright.split('_');
        }
      },
      deep: true,
    },
  },
  components:{
    Logo
  },
  methods: {
    imageIsExist: function (url) {
      return new Promise((resolve) => {
        var img = new Image();
        img.onload = function () {
          if (this.complete == true) {
            resolve(true);
            img = null;
          }
        };
        img.onerror = function () {
          resolve(false);
          img = null;
        };
        img.src = url;
      });
    },
    async indexImgUrl(name) {
      this.logoUrl = `${location.origin}/infoplus/file/enterprise/${this.EnterpriseId}/icon/footer_logo`;
      let that = this;
      await this.imageIsExist(this.logoUrl).then((res) => {
        that.footerBool = res;
      });
    },
  },
  computed: {
    EnterpriseId() {
      if (this.$store.getters.getUserInfo.enterprise) {
        return this.$store.getters.getUserInfo.enterprise.id;
      } else {
        return "";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div_footer_under {
  background: #9a0000;
  padding: 15px 0;
  box-sizing: border-box;
}
.div_footer_under .footer_nav a {
	color: #fff;
	display: inline-block;
	width: 100px;
}
.display_center{
  display: flex;
  justify-content: center;
}
.div_footer_img img{
  height: 50px;
}
.line_h{
  color: #FFFFFF;
  font-size: 16px;
  height: 35px;
  line-height: 35px;
  text-align: center;
}
.footer_logo {
	display: block;
	max-height: 120px;
}

.gdut_footer {
	height: 45px;
	line-height: 45px;
	background: #000;
	text-align: center;
	color: #fff;
}

.gdut_footer span {
	margin: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/Footer.vue